import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-blank-work-space',
  templateUrl: './blank-work-space.component.html',
  styleUrls: ['./blank-work-space.component.css']
})
export class BlankWorkSpaceComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    console.log("blankspace initialized checking login")
    // check to see if you are logged in... if so, redirect to home page
    if (localStorage.getItem('storedPatient')) {
      this.router.navigate(['/patientportal/home']);
    }
    
    else if (localStorage.getItem('storedUser')) {
      this.router.navigate(['/landing/case-view']);
    }
    else {
      console.log('BlankWorkSpaceComponent ngOnInit: User not logged in. Redirecting to login page.');
      this.router.navigate(['/login']);
    }

    
  }
}
